function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none"
}, React.createElement("circle", {
  cx: 64.34,
  cy: 59.85,
  r: 59.85,
  fill: "#CFECF3"
}), React.createElement("circle", {
  cx: 36.25,
  cy: 49.2,
  r: 15.1,
  fill: "#CFD0D0"
}), React.createElement("circle", {
  cx: 20.39,
  cy: 52.98,
  r: 11.33,
  fill: "#CFD0D0"
}), React.createElement("circle", {
  cx: 61.17,
  cy: 52.98,
  r: 11.33,
  fill: "#CFD0D0"
}), React.createElement("circle", {
  cx: 6.8,
  cy: 57.51,
  r: 6.8,
  fill: "#CFD0D0"
}), React.createElement("rect", {
  width: 55.89,
  height: 10.57,
  x: 6.04,
  y: 53.74,
  fill: "#CFD0D0",
  rx: 2.87,
  transform: "rotate(180 33.985 59.025)"
}), React.createElement("circle", {
  cx: 91.64,
  cy: 13.28,
  r: 8.88,
  fill: "#CFD0D0"
}), React.createElement("circle", {
  cx: 82.31,
  cy: 15.5,
  r: 6.66,
  fill: "#CFD0D0"
}), React.createElement("circle", {
  cx: 106.29,
  cy: 15.5,
  r: 6.66,
  fill: "#CFD0D0"
}), React.createElement("circle", {
  cx: 74.32,
  cy: 18.16,
  r: 4,
  fill: "#CFD0D0"
}), React.createElement("rect", {
  width: 32.85,
  height: 6.21,
  x: 73.88,
  y: 15.95,
  fill: "#CFD0D0",
  rx: 1.69,
  transform: "rotate(180 90.305 19.055)"
}), React.createElement("circle", {
  cx: 101.03,
  cy: 92,
  r: 7.65,
  fill: "#CFD0D0"
}), React.createElement("circle", {
  cx: 109.07,
  cy: 93.91,
  r: 5.74,
  fill: "#CFD0D0"
}), React.createElement("circle", {
  cx: 88.4,
  cy: 93.91,
  r: 5.74,
  fill: "#CFD0D0"
}), React.createElement("circle", {
  cx: 115.95,
  cy: 96.21,
  r: 3.44,
  fill: "#CFD0D0"
}), React.createElement("rect", {
  width: 28.31,
  height: 5.36,
  x: 88.02,
  y: 94.3,
  fill: "#CFD0D0",
  rx: 1.46
}), React.createElement("circle", {
  cx: 38.96,
  cy: 103.1,
  r: 9.4,
  fill: "#CFD0D0"
}), React.createElement("circle", {
  cx: 48.83,
  cy: 105.45,
  r: 7.05,
  fill: "#CFD0D0"
}), React.createElement("circle", {
  cx: 23.44,
  cy: 105.45,
  r: 7.05,
  fill: "#CFD0D0"
}), React.createElement("circle", {
  cx: 57.3,
  cy: 108.27,
  r: 4.23,
  fill: "#CFD0D0"
}), React.createElement("rect", {
  width: 34.8,
  height: 6.58,
  x: 22.97,
  y: 105.92,
  fill: "#CFD0D0",
  rx: 1.79
}), React.createElement("circle", {
  cx: 97.28,
  cy: 40.97,
  r: 4.41,
  fill: "#8B8A8B"
}), React.createElement("circle", {
  cx: 101.32,
  cy: 42.81,
  r: 2.57,
  fill: "#8B8A8B"
}), React.createElement("circle", {
  cx: 92.87,
  cy: 42.44,
  r: 2.94,
  fill: "#8B8A8B"
}), React.createElement("path", {
  fill: "#8B8A8B",
  d: "M92.14 42.44H101.69V45.379999999999995H92.14z"
}), React.createElement("circle", {
  cx: 91.39,
  cy: 65.47,
  r: 6.03,
  fill: "#CFD0D0"
}), React.createElement("circle", {
  cx: 96.91,
  cy: 67.98,
  r: 3.51,
  fill: "#CFD0D0"
}), React.createElement("circle", {
  cx: 85.36,
  cy: 67.48,
  r: 4.02,
  fill: "#CFD0D0"
}), React.createElement("path", {
  fill: "#CFD0D0",
  d: "M84.36 67.48H97.41V71.5H84.36z"
}), React.createElement("circle", {
  cx: 52.87,
  cy: 69.82,
  r: 10.11,
  fill: "#8B8A8B"
}), React.createElement("circle", {
  cx: 62.14,
  cy: 74.03,
  r: 5.9,
  fill: "#8B8A8B"
}), React.createElement("circle", {
  cx: 42.76,
  cy: 73.19,
  r: 6.74,
  fill: "#8B8A8B"
}), React.createElement("path", {
  fill: "#8B8A8B",
  d: "M41.07 73.19H62.980000000000004V79.92999999999999H41.07z"
}), React.createElement("circle", {
  cx: 51.24,
  cy: 19.82,
  r: 4.41,
  fill: "#8B8A8B"
}), React.createElement("circle", {
  cx: 55.28,
  cy: 21.65,
  r: 2.57,
  fill: "#8B8A8B"
}), React.createElement("circle", {
  cx: 46.83,
  cy: 21.29,
  r: 2.94,
  fill: "#8B8A8B"
}), React.createElement("path", {
  fill: "#8B8A8B",
  d: "M46.1 21.29H55.650000000000006V24.23H46.1z"
}));

var SvgPollution = function SvgPollution(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 125,
    height: 120,
    viewBox: "0 0 125 120",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPollution, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pollution.4207d52d.svg";
export { ForwardRef as ReactComponent };